import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import perosn from "../Assets/women.png";
import BookingDetails from "./BookingDetails";
import PackageDetails from "./PackageDetails";
import { Modal, ModalBody } from "reactstrap";
import ActivePackages from "./ActivePackages";

function Profile() {
    const [modal, setModal] = useState(false);
  
  const [selectedDates, setSelectedDates] = useState([]);
  const userData = localStorage.getItem("AluraUser");
  const [view, setView] = useState("Booking");
  const parseData = userData && JSON.parse(userData);
  const handleDateClick = (date) => {
    const formattedDate = date.toDateString();
    setSelectedDates((prevDates) =>
      prevDates.includes(formattedDate)
        ? prevDates.filter((d) => d !== formattedDate)
        : [...prevDates, formattedDate]
    );
  };

  const tileClassName = ({ date }) => {
    const today = new Date().toDateString();
    const formattedDate = date.toDateString();

    if (selectedDates.includes(formattedDate)) {
      return "selected-day";
    }
    if (formattedDate === today) {
      return "current-day";
    }
    return "";
  };

  return (
    <>
      <Navbar />
      <div className='aboutbanner'>
    <h3>Profile</h3>
    <p>HOME - PROFILE</p>

    </div>
      <div className="profile">
        <div className="profile-info">
          <div className="profile-img">
          <div className="poro-img">
          <h3>

          {parseData?.name?.[0]?.toUpperCase()}
          </h3>
          </div>
            {/* <img src={perosn} /> */}
            <div className="edit" onClick={() => setModal(true)}>
            <i class="bi bi-pencil-fill"></i>
            </div>
          </div>
          <br />
          <div className="profile-div">
            <h2>{parseData?.name}</h2>
            <h3>{parseData?.email}</h3>
            <h3>{parseData?.mobile}</h3>
          </div>
        </div>
        <div></div>
        <div className="profile-plan-2">
        <div
  className="toggle-buttons"
  style={{ display: "flex", gap: "10px", marginBottom: "20px" }}
>
  <button
    onClick={() => setView("Booking")}
    style={{
      padding: "10px 20px",
      backgroundColor: view === "Booking" ? "#849348" : "#fff",
      color: view === "Booking" ? "#fff" : "#849348",
      border: "1px solid #849348",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    }}
  >
    Active Packages
  </button>
  <button
    onClick={() => setView("Details")}
    style={{
      padding: "10px 20px",
      backgroundColor: view === "Details" ? "#849348" : "#fff",
      color: view === "Details" ? "#fff" : "#849348",
      border: "1px solid #849348",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    }}
  >
    Booking Details
  </button>
  <button
    onClick={() => setView("Package")}
    style={{
      padding: "10px 20px",
      backgroundColor: view === "Package" ? "#849348" : "#fff",
      color: view === "Package" ? "#fff" : "#849348",
      border: "1px solid #849348",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    }}
  >
    Package Details
  </button>
</div>

{/* Conditional rendering for views */}
{view === "Booking" ? (
  <ActivePackages />
) : view === "Details" ? (
  <BookingDetails />
) : (
  <PackageDetails />
)}
</div>


        {/* <div className="profile-plan">
          <div className="">
            <h2 className="Select">Remaning Days</h2>
            <br />
            <div className="encourage-cards">
              <div>
                <div className="encourage-card">
                  <img src={perosn} />
                  <h3>March 20</h3>
                  <h4>Sat</h4>
                  <p>
                    Breathe in peace, breathe out stress. Embrace the power of
                    yoga!
                  </p>
                </div>
              </div>

              <div>
                <div className="encourage-card">
                  <img src={perosn} />
                  <h3>March 21</h3>
                  <h4>Sat</h4>
                  <p>
                    A few minutes of yoga today, a lifetime of wellness
                    tomorrow.
                  </p>
                </div>
              </div>
              <div>
                <div className="encourage-card">
                  <img src={perosn} />
                  <h3>March 22</h3>
                  <h4>Sat</h4>
                  <p>
                    Stretch your body, calm your mind, and uplift your soul.
                  </p>
                </div>
              </div>
              <div>
                <div className="encourage-card">
                  <img src={perosn} />
                  <h3>March 23</h3>
                  <h4>Sat</h4>
                  <p>
                    Start your day with yoga and feel the energy flow within!
                  </p>
                </div>
              </div>
              <div>
                <div className="encourage-card">
                  <img src={perosn} />
                  <h3>March 24</h3>
                  <h4>Sat</h4>
                  <p>
                    Find your balance, find your strength, find your inner
                    peace.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <Modal size="md" isOpen={modal} toggle={() => setModal(!modal)}>
        <ModalBody>
          <div className="Edit-Profile">
          <h3>Edit Profile</h3>
           <label>Name</label>
           <input placeholder="Name"/>
           <label>Email</label>
           <input placeholder="Email"/>
           <label>Mobile No.</label>
           <input placeholder="Mobile No."/>
          
           <button>Save</button>
          </div>
        </ModalBody>
      </Modal>
      <Footer />
    </>
  );
}

export default Profile;

{
  /* <Calendar 
        onClickDay={handleDateClick} 
        tileClassName={tileClassName} 
        className='cl'
      />
      <div className="mt-4">
        <p className="font-semibold">Selected Days: {selectedDates.length}</p>
        <ul>
          {selectedDates.map((date, index) => (
            <li key={index} className="text-sm text-gray-600">{date}</li>
          ))}
        </ul>
      </div> */
}
